import vehicles from './vehicles';
import exportSagas from './export';

export default function* () {
    yield* [...vehicles, ...exportSagas];
}